import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { collaboratorLinksApi } from '../api/collaborator-links.api';
import { getErrorMessage } from '@/core/api/response-handler';

const key = (schoolId: string) => ['collaborator-links', schoolId] as const;

export function useCollaboratorLinks(schoolId: string | undefined) {
    const queryClient = useQueryClient();
    const links = useQuery({
        queryKey: key(schoolId ?? ''),
        queryFn: () => collaboratorLinksApi.list(schoolId as string),
        enabled: Boolean(schoolId),
    });
    const invalidate = () => queryClient.invalidateQueries({ queryKey: key(schoolId ?? '') });

    const create = useMutation({
        mutationFn: (label: string) => collaboratorLinksApi.create(schoolId as string, label),
        onSuccess: () => { toast.success('Link creat'); invalidate(); },
        onError: (e) => toast.error(getErrorMessage(e, 'Eroare la crearea linkului')),
    });
    const revoke = useMutation({
        mutationFn: (linkId: string) => collaboratorLinksApi.revoke(schoolId as string, linkId),
        onSuccess: () => { toast.success('Link revocat'); invalidate(); },
        onError: (e) => toast.error(getErrorMessage(e, 'Eroare la revocare')),
    });
    return { links, create, revoke };
}
